(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-strip"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-service-strip]').forEach((root) => {
    if (root.dataset.s9Ready === 'true') return;
    root.dataset.s9Ready = 'true';

    const track = root.querySelector('[data-nj-track]');
    const dots = Array.from(root.querySelectorAll('[data-nj-dot]'));
    const prev = root.querySelector('[data-nj-prev]');
    const next = root.querySelector('[data-nj-next]');
    if (!track) return;

    const slideWidth = () => {
      const item = track.querySelector('.service-strip__item');
      return item ? item.getBoundingClientRect().width : track.clientWidth;
    };

    const current = () => Math.round(track.scrollLeft / Math.max(slideWidth(), 1));

    const goTo = (index) => {
      const max = track.children.length - 1;
      const target = Math.min(Math.max(index, 0), max);
      track.scrollTo({ left: target * slideWidth(), behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => goTo(current() - 1));
    if (next) next.addEventListener('click', () => goTo(current() + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.s9Dot)));
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        const active = current();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
        ticking = false;
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
